// Une période est stockée sur le gisement sous la forme "<Mois FR> <Année>", ex. "Janvier 2026".
export interface PeriodeMois {
  mois: string;
  annee: number;
}

export function parsePeriodeMois(periode: string): PeriodeMois {
  const match = /^\s*(\S+)\s+(\d{4})\s*$/.exec(periode || '');
  return match ? { mois: match[1], annee: Number(match[2]) } : { mois: null, annee: null };
}

export function formatPeriodeMois(mois: string, annee: number): string {
  return mois && annee ? `${mois} ${annee}` : null;
}

// Années proposées : 5 ans en arrière jusqu'à l'année suivante, plus l'année déjà saisie si hors plage.
export function anneesPeriode(currentYear: number, anneeSaisie?: number): number[] {
  const annees = [];
  for (let a = currentYear + 1; a >= currentYear - 5; a--) {
    annees.push(a);
  }
  if (anneeSaisie && !annees.includes(anneeSaisie)) {
    annees.push(anneeSaisie);
    annees.sort((a, b) => b - a);
  }
  return annees;
}
